import React from 'react';
import { IconProps } from '../types/types';

const AVAX: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z" fill="#E84142"/><path d="M13.527 10.26c.347-.599.906-.599 1.252 0l2.158 3.787c.346.599.063 1.087-.63 1.087h-4.346c-.686 0-.969-.488-.63-1.087l2.197-3.787ZM9.354 2.969c.347-.599.898-.599 1.244 0l.48.866 1.135 1.992a2.07 2.07 0 0 1 0 1.803l-3.804 6.59a2 2 0 0 1-1.559.914H3.693c-.693 0-.977-.48-.63-1.087L9.354 2.968Z" fill="#fff"/></svg>
);

export default AVAX;
